module.exports = __webpack_public_path__ + "img/cont-04-crescita.ee9829d0.svg";